import Dropdown from './components/Dropdown'
import Footer from './components/Footer'
import Header from './components/Header'
import './css/App.css'

function App() {

  return (
    <div className="App">
      <Header />
      <Dropdown />
      <Footer />
    </div>
  )
}

export default App
